import React, { useState } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IModalProps } from '../../interfaces/Modal.interface';

// STYLES
import { Actions, Close, Container, Content, Overlay, Subtitle, Title, TitleContent } from './styles';

const Modal: React.FC<IModalProps> = ({
  children,
  title,
  icon,
  buttonLeft,
  buttonRight,
  themeProp,
  subtitle,
  centered,
  alert,
  withIcon
}: IModalProps) => {
  const twoActions = buttonLeft != null && buttonRight != null;
  return (
    <Overlay>
      <Container themeProp={themeProp}>
        <Title centered={centered} themeProp={themeProp} alert={alert}>
          <>
            <Icon type={icon} />
            <TitleContent>{title}</TitleContent>
          </>
          <Close themeProp={themeProp} withIcon={withIcon}>
            <Icon type={Icons.CLOSE} />
          </Close>
        </Title>
        {subtitle != null && (
          <Subtitle centered={centered} themeProp={themeProp}>
            {subtitle}
          </Subtitle>
        )}
        {children != '' && children != null && (
          <Content themeProp={themeProp} centered={centered}>
            {children}
          </Content>
        )}
        <Actions themeProp={themeProp} twoActions={twoActions}>
          {buttonLeft}
          {buttonRight}
        </Actions>
      </Container>
    </Overlay>
  );
};

export default Modal;
